/**
 * Работа с изображениями
 * @packageDocumentation
 */

import punycode from 'punycode';

/**
 * Скачать изображение, переданное в виде строки
 * @param imageStr - адресс картинки
 * @param imageName - имя файла при загрузке, по умолчанию download
 */
export const downloadImageFromString = (imageStr: string, imageName: string = 'download'): void => {
	const a = document.createElement('a');
	a.download = imageName;
	a.href = imageStr;
	a.click();
};

/**
 * Сгенерировать html картинку с фавиконкой сайта
 * @param url - адрес сайта
 * @param isBig - если true, картинка будет 120px, иначе 32px
 */
export const genFaviconImgHtml = (url: string, isBig: boolean): string => {
	let size = 32;
	if (isBig) size = 120;

	url = url.replace(/^\w+:\/\/|^www\.|\/.*/g, '');
	url = punycode.toASCII(url);

	const onloadAttr = `
		onload="
			var that = this;
			$.ajax({
				type:'get',
				url:this.src,
				success:function(res){ if(res.length > 100) that.className='top-favicon'; },
				error:function(){ }
			});
		"
	`;

	//	return '<img src="https://www.google.com/s2/favicons?domain=' + url + '" class="top-favicon empty"> ' + onloadAttr + '>';
	return '<img src="https://favicon.yandex.net/favicon/' + url + '?size=' + size + '" class="top-favicon empty" ' + onloadAttr + ' alt="">';
};
